"use client";
import { Image } from "antd";
import React from "react";

 const CommonImage = ({ src, alt, className }) => {
  return (
    <div className={className}>
      <Image src={src} alt={alt} preview={false} className="!w-full !h-auto" priority="true"   />
    </div>
  );
};

export default CommonImage;